import React, { useEffect, useRef, useState } from 'react';
import './ReelsMobile.css';

const videoFiles = [
  'cut1.mp4',
  'cut2.mp4',
  'cut3.mp4',
  'cut4.mp4',
  'cut5.mp4',
  'cut6.mp4',
  'cut7.mp4',
  'cut8.mp4',
];

const Reels = () => {
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  
  // Duplicate the videos array to create a seamless loop
  const loopedVideos = [...videoFiles, ...videoFiles];

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    let animationFrameId;
    let scrollAmount = container.scrollWidth / 2; // Start from the middle for seamless loop

    // Adjust scroll speed based on device for slower continuous scroll (negative for right to left)
    const scrollSpeed = isMobile ? -0.05 : -0.08;

    const step = () => {
      if (container) {
        scrollAmount += scrollSpeed;
        // Reset scroll amount when it reaches the beginning of the first set of videos
        if (scrollAmount <= 0) {
          scrollAmount = container.scrollWidth / 2;
        }
        container.scrollLeft = scrollAmount;
      }
      animationFrameId = requestAnimationFrame(step);
    };

    animationFrameId = requestAnimationFrame(step);

    return () => cancelAnimationFrame(animationFrameId);
  }, [isMobile]);

  return (
    <div className="reels-wrapper">
      <h2 className="reels-title">
        <span className="reels-icon" role="img" aria-hidden="true"></span>
        Signature Styles Gallery
      </h2>
      <p className="reels-subtitle">
        {isMobile 
          ? "Swipe to explore our styles" 
          : "Discover the artistry of precision haircuts and styling excellence"
        }
      </p>
      <div className={`reels-container ${isMobile ? 'mobile-scroll' : 'desktop-scroll'}`} ref={containerRef}>
        {loopedVideos.map((video, index) => (
          <div className="reel" key={index}>
            <video
              src={require(`./assets/${video}`)}
              className="reel-video"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              poster={`./assets/poster-${index % 8 + 1}.jpg`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reels;
